import React from 'react'
import forOwn from 'mout/object/forOwn'
import sortByPropText from '../../../../helpers/content/manageSets/sortByPropText';
import { SkillBar, AnswerKey } from './'
import computeSummaryNodeData from '../../../../helpers/assessment/computeSummaryNodeData';
import getAutoTutorRecommendations from '../../../../helpers/assessment/getAutoTutorRecommendations';

export default function SubjectBreakdown({studentScore, displayName, nodes, subtest, }) {
  // create an array of the level 1 nodes and their scores, then map them to SkillBar
  const byNode = studentScore.scoring.byNode[subtest.setId]
  const bySubtest = studentScore.scoring.bySubtest[subtest.setId]
  const summaryNodes = computeSummaryNodeData(nodes, byNode, subtest)
  const subject = subtest.displayName
  const rec = getAutoTutorRecommendations({byNode, bySubtest, subject, nodes}, true)

  return (
    <div className={`${displayName} Breakdown`}>
      <hgroup>
        <img 
          className='SubjectIcon' 
          src={`https://bellwork-cg1.firebaseapp.com/img/${displayName.toLowerCase()}-icon.svg`} 
          alt='' 
        />
        <h3 className='Title'>{displayName}</h3>
      </hgroup>
      {
        summaryNodes.map(node => {
          if (node.possible) {
            return (
              <SkillBar
                name={node.name}
                percent={Math.round(node.raw / node.possible * 100)}
                key={`StSk${node.name}${studentScore.userId}`}
              />
            )
          } else {
            return null
          }
        })
      }
      <div className='bottom-section'>
				<div className='top-area-to-improve'>
					<h5 className='top-area-title'>Top Area to Improve</h5>
          <h6 className='top-area'>
            {rec && rec.name ? rec.name : 'Time Management'}
          </h6>
				</div>
        <AnswerKey 
          answers={studentScore.answers[subtest.setId]}
          answersByItem={studentScore.answersByItem && studentScore.answersByItem[subtest.setId]}
          byItem={studentScore.scoring.byItem[subtest.setId]}
        />
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/StudentReport/SubjectBreakdown.js